import React, { ReactElement, useCallback, useEffect, useState } from 'react';
import Table from 'react-bootstrap/Table';
import i18next from 'i18next';
import TelerehabilitationProgramModal from './TelerehabilitationProgramModal';
import { useAuthFetchFromRestAPI } from '../../../util/api';
import { TelerehabilitationProgramDto } from '../../../../../shared/dtos/telerehabilitationProgram.dto';
import LoadingSpinner from '../../../components/LoadingSpinner';
import PrimaryButton from '../../../components/PrimaryButton';

const TelerehabilitationPrograms: () => ReactElement = () => {
  const { authFetch } = useAuthFetchFromRestAPI();
  
  const [isLoading, setIsLoading] = useState(false);
  const [rows, setRows] = useState<TelerehabilitationProgramDto[]>([]);

  const [showModal, setShowModal] = useState(false);
  const [editTelerehabilitationProgram, setEditTelerehabilitationProgram] = useState<TelerehabilitationProgramDto | null>(null);
    

  const fetchTelerehabilitationPrograms: () => Promise<void> = useCallback(async () => {
    setIsLoading(true);

    try {
      const result: TelerehabilitationProgramDto[] = await authFetch('/api/v1/telerehabilitation-program');
      setRows(result);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }, [authFetch]);

  useEffect(() => {
    void fetchTelerehabilitationPrograms();
  }, [fetchTelerehabilitationPrograms]);
    
  
  return (
    <div className="bg-white p-4">
      {isLoading && (
        <LoadingSpinner />
      )}

      <div className="d-flex justify-content-end mb-3">
        <PrimaryButton
          className="ms-2"
          onClick={() => {
            setEditTelerehabilitationProgram(null);
            setShowModal(true);
          }}
          disabled={isLoading}>
          {i18next.t('generic.create')}
        </PrimaryButton>
      </div>

      {!isLoading && (
        <Table striped bordered hover responsive className="h-75 overflow-auto">
          <thead>
            <tr>
              <th className="centered-td">{i18next.t('adminTelerehabilitationProgram.germanName')}</th>
              <th className="centered-td">{i18next.t('adminTelerehabilitationProgram.englishName')}</th>
              <th className="centered-td">{i18next.t('adminTelerehabilitationProgram.targetTrainingMinutes')}</th>
              <th className="centered-td">{i18next.t('adminTelerehabilitationProgram.maximumBillableTherapyUnits')}</th>
              <th className="centered-td">{i18next.t('adminTelerehabilitationProgram.maximumBillableTeleTherapyUnits')}</th>
              <th className="centered-td">{i18next.t('adminTelerehabilitationProgram.maximumEnduranceTrainingPercentage')}</th>
              <th className="centered-td">{i18next.t('adminTelerehabilitationProgram.basicPackage')}</th>
              <th className="centered-td">{i18next.t('adminTelerehabilitationProgram.teConversion')}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {rows.map((program: TelerehabilitationProgramDto)=> (
              <tr key={program.id}>
                <td className="centered-td">{program.germanName}</td>
                <td className="centered-td">{program.englishName}</td>
                <td className="centered-td">{program.targetTrainingMinutes}</td>
                <td className="centered-td">{program.maximumBillableTherapyUnits} TE</td>
                <td className="centered-td">{program.maximumBillableTeleTherapyUnits} TE</td>
                <td className="centered-td">{program.maximumEnduranceTrainingPercentage}%</td>
                <td className="centered-td">{program.basicPackage} TE</td>
                <td className="centered-td">{program.teConversion}</td>
                <td className='centered-td'>
                  <PrimaryButton onClick={() => {
                    setEditTelerehabilitationProgram(program);
                    setShowModal(true);
                  }}>
                    { i18next.t('generic.edit')}
                  </PrimaryButton>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}

      <TelerehabilitationProgramModal
        show={showModal}
        telerehabilitationProgram={editTelerehabilitationProgram}
        onClose={() => {
          setShowModal(false);
          setEditTelerehabilitationProgram(null);
        }}
        onSave={() => {
          void fetchTelerehabilitationPrograms();
        }}
      />
    </div>
  );
};
export default TelerehabilitationPrograms;
